<template>
  <NuxtLink
    :class="`py-8 pl-5 pr-16 text-${design} border-${design} group relative flex cursor-pointer`"
  >
    <icon :icon="icon" class="mr-3 h-6 w-5"></icon><slot></slot>
    <div
      :class="`bg-${design} transition-width absolute bottom-0 left-0 right-0 mx-auto h-[3px] w-0 group-hover:w-full`"
    ></div>
  </NuxtLink>
</template>

<script>
export default {
  props: {
    design: {
      type: String,
      default: "primary",
    },
    icon: {
      type: String,
      default: "loupe",
    },
  },
};
</script>
